if (!customElements.get('av-rhinokeys-addon')) {
  customElements.define('av-rhinokeys-addon', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.form.addEventListener('change', () => this.updateSelection(), {signal:this.controller.signal});
      this.form.addEventListener('submit', event => this.addKeyboard(event), {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
    updateSelection() {
      const option = this.form.querySelector('input[name="id"]:checked');
      if (!option) return;
      const photo = this.querySelector('.av-rkc__photo');
      photo.removeAttribute('srcset');
      photo.src = option.dataset.image;
      photo.alt = option.dataset.name;
      this.querySelector('[data-rkc-price]').textContent = option.dataset.price;
      this.querySelector('[data-rkc-label]').textContent = this.dataset.addLabel;
      this.status.hidden = true;
      this.querySelector('.av-rkc__cart').hidden = true;
      this.removeAttribute('data-error');
    }
    async addKeyboard(event) {
      event.preventDefault();
      if (this.busy) return;
      const option = this.form.querySelector('input[name="id"]:checked');
      if (!option || option.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.querySelector('[data-rkc-label]').textContent = this.dataset.addingLabel;
      this.status.hidden = true;
      this.removeAttribute('data-error');
      const color = option.dataset.name;
      let added = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true, detail:{sections}}));
        const data = new FormData(this.form);
        data.set('sections', [...new Set(sections)].slice(0,5).join(','));
        data.set('sections_url', window.location.pathname);
        const response = await fetch(`${this.dataset.root}cart/add.js`, {method:'POST', body:data, headers:{'X-Requested-With':'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.errorLabel);
        added = true;
        this.status.textContent = `${this.dataset.addedLabel} ${color}.`;
        this.status.hidden = false;
        this.querySelector('.av-rkc__cart').hidden = false;
        const cartResponse = await fetch(`${this.dataset.root}cart.js`);
        if (!cartResponse.ok) throw new Error('cart refresh');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        this.form.dispatchEvent(new CustomEvent('variant:add', {bubbles:true, detail:{items:result.items || [result], cart, onSuccessDo:'force_open_drawer'}}));
        if (sections.length && result.sections && sections.every(id => result.sections[id])) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add', onSuccessDo:'force_open_drawer', cart}}));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        }
      } catch (error) {
        if (!added) {
          this.setAttribute('data-error', '');
          this.status.textContent = error.message === 'Failed to fetch' ? this.dataset.errorLabel : error.message;
          this.status.hidden = false;
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        }
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.querySelector('[data-rkc-label]').textContent = this.dataset.addLabel;
      }
    }
  });
}
